PresentersBase = require('../../../backbone_base/frontend/presenters/base')
SupportUtilsHelper = require('../../../support/frontend/helpers/utils')
SupportAPIHelper = require('../../../support/frontend/helpers/API')

SharedUtilsHelper =
  toHtml: (template, hash, scope) =>
    if template?.render?
      template.render PresentersBase.toHashWithHelpers hash, scope

  redirectToFaq : () ->
    window.location.href = "#{window.FAQBASEURL}"

  redirectToHelpWizard : () ->
    window.location.href = "#{window.SUPPORTBASEURL}"

  scrollTo : ($container) ->
    if $container
      hash =
        scrollTop: $container.offset()?.top
      $('html, body').animate(hash, 1000)

  toggleCallUs: (id) ->
    addWrapperLinkOverCallUs()
    experiment = $('span.lnk-call-us').attr('id')
    $('span.lnk-call-us').removeAttr('data-bhw-path')
    $('span.lnk-call-us').removeAttr('data-bhw')
    $('span.lnk-call-us').attr("data-bhw", "phone-number-#{experiment}-#{id}")
    $('span.lnk-call-us').data("bhw", "phone-number-#{experiment}-#{id}")

  addWrapperLinkOverCallUs: ->
    $('.contact-number').addClass('hide')
    $('span.lnk-call-us').addClass('lnk')

  propagateEventBeforeReplacingElements: (cb) ->
    setTimeout(cb)
    return true

  removeSpecificParamFromUrl: (url, parameter) ->
    if url.indexOf('#') > 0
      hashPresent = true
      hash = url.substr(url.indexOf('#')+1)
    urlparts = url.split("?")
    if urlparts.length >= 2
      urlBase = urlparts.shift() #get first part, and remove from array
      queryString = urlparts.join("?") #join it back up
      prefix = encodeURIComponent(parameter) + "="
      pars = queryString.split(/[&;]/g)
      i = pars.length #reverse iteration as may be destructive

      while i-- > 0
        #idiom for string.startsWith
        pars.splice i, 1  if pars[i].lastIndexOf(prefix, 0) isnt -1
      url = urlBase + "?" + pars.join("&")
    if url.indexOf('#') == -1 and hashPresent
      url = url + '#' + hash
    url

  abortAjaxRequests: (requests) ->
    _.each requests, (req) ->
      req.abort()
    null

  startTimer: (timer) ->


  stopTimer: (timer) ->

  isIntl: ->
    checkIfIsEMEAByCountryCluster(window.country?.cluster)

  isUS: ->
    checkIfIsUSByCountryCluster(window.country?.cluster)

  isNeedish: ->
    checkIfIsNEEDISHByCountryCluster(window.country?.cluster)

  checkIfIsUSByCountry : (country) ->
    getCountryCluster(country) is 'US'

  checkIfIsEMEAByCountry : (country) ->
    getCountryCluster(country) is 'EMEA'

  checkIfIsNEEDISHByCountry : (country) ->
    getCountryCluster(country) is 'NEEDISH'

  checkIfIsUSByCountryCluster : (countryCluster) ->
    countryCluster is 'US'

  checkIfIsEMEAByCountryCluster : (countryCluster) ->
    countryCluster is 'EMEA'

  checkIfIsNEEDISHByCountryCluster : (countryCluster) ->
    countryCluster is 'NEEDISH'

  getCountryCluster : (country) ->
    country = country.toUpperCase() if country?
    return country if country in [ 'US', 'IN' ]
    return 'ASIA' if country in [ 'PH', 'TH' ]
    return 'NEEDISH' if country in [ 'CL', 'CO', 'MX', 'PA', 'PE', 'PR', 'UY' ]
    return 'EMEA'

  getCallUsMsg: ->
    customPhoneNumber = getCustomPhoneNumber()
    if customPhoneNumber?
      I18n.translate('js.modules.shared.call_us_message_with_custom_phone_number', {custom_phone_number: customPhoneNumber })
    else
      I18n.translate('js.modules.shared.call_us_message')

  getCustomPhoneNumber: ->
    dealType = Groupon.Support.currentOrder?.DEAL_TYPE
    if phoneNumbers?[dealType]?
        return phoneNumbers[dealType].custom

  evaluate: (key) ->
   key? && (key is true || key is "true")

  isCMSEnabled: ->
    experiments?.shouldDisplayCMSContentForUS || not isUS()

  showDOMElems: (DOMElems) ->
    addShowClass DOMElems
    removeHideClass DOMElems

  showDOMElemsInline: (DOMElems)->
    removeHideClass DOMElems
    addInlineClass DOMElems

  hideDOMElems: (DOMElems) ->
    removeShowClass DOMElems
    addHideClass DOMElems

  addShowClass: (DOMElems) ->
    addClassToDOMElems DOMElems, 'show'

  addInlineClass: (DOMElems) ->
    addClassToDOMElems DOMElems, 'display-inline'

  removeDOMElemsInline: (DOMElems)->
    removeClassFromDOMElems DOMElems, 'display-inline'

  removeHideClass: (DOMElems) ->
    removeClassFromDOMElems DOMElems, 'hide'

  removeShowClass: (DOMElems) ->
    removeClassFromDOMElems DOMElems, 'show'

  addHideClass: (DOMElems) ->
    addClassToDOMElems DOMElems, 'hide'

  addBtnPrimaryClass: (DOMElems) ->
    addClassToDOMElems DOMElems, 'btn-primary'

  addBtnSecondaryClass: (DOMElems) ->
    addClassToDOMElems DOMElems, 'btn-invert'

  addPreferredContactClass: (DOMElems) ->
    addClassToDOMElems DOMElems, 'preferred-contact-channel'

  removeBtnPrimaryClass: (DOMElems) ->
    removeClassFromDOMElems DOMElems, 'btn-primary'

  removeBtnSecondaryClass: (DOMElems) ->
    removeClassFromDOMElems DOMElems, 'btn-invert'

  removePreferredContactClass: (DOMElems) ->
    removeClassFromDOMElems DOMElems, 'preferred-contact-channel'

  addBloodHoundTagToDOMElems: (DOMElems, tagName) ->
    manipulateDOMElems DOMElems, window.addBloodHoundTagToDOMElem, tagName

  addClassToDOMElems: (DOMElems, className) ->
    manipulateDOMElems DOMElems, window.addClassToDOMElem, className

  removeClassFromDOMElems: (DOMElems, className) ->
    manipulateDOMElems DOMElems, window.removeClassFromDOMElem, className

  manipulateDOMElems: (DOMElems, manipulateDOMElem, CSSSelector) ->
    DOMElems = getInArrayFormat DOMElems
    _.each(DOMElems, (DOMElem, index) =>
      manipulateDOMElem DOMElem, CSSSelector
    )

  addClassToDOMElem: (DOMElem, className) ->
    DOMElem.addClass className

  addBloodHoundTagToDOMElem: (DOMElem, tagName) ->
    DOMElem.removeAttr('data-bhw-path')
    DOMElem.removeAttr('data-bhw')
    DOMElem.attr("data-bhw", tagName)
    DOMElem.data("bhw", tagName)

  removeClassFromDOMElem: (DOMElem, className) ->
    DOMElem.removeClass className

  getInArrayFormat: (elements) ->
    if _.isArray(elements) then elements else [elements]

  createTicket: (data, successCb, errorCb, loadElem, loadingElemHeight)=>
    propagateEventBeforeReplacingElements( ->
      SupportUtilsHelper.showLoading(loadElem, loadingElemHeight)
      url = "#{window.SUPPORTBASEURL}/ticket/create"
      method = "POST"
      tHubData =
        ticketParams: data,
        user: window.currentUser?.id
      TrackingHub.add('ticket-create-params', {params: tHubData})
      SupportAPIHelper.call url, method, data, successCb, errorCb, false
    )

module.exports = SharedUtilsHelper
